import {ADD_PLACE, REMOVE_PLACE, UPDATE_PATH} from "../actions";

const itinerary = (state = [], action) => {
    switch (action.type) {
        case ADD_PLACE:
            return [
                ...state,
                action.place
            ];
        case REMOVE_PLACE:
            return state.filter(place => place !== action.place);
        case UPDATE_PATH:
            if (action.properties) {
                let changes = false;
                for (let i = 0; i < action.properties.segments.length; i++) {
                    if (state[i + 1].distance !== action.properties.segments[i].distance || state[i + 1].duration !== action.properties.segments[i].duration) {
                        changes = true;
                    }
                }
                if (changes) {
                    let newState = Object.assign([], state);
                    for (let i = 0; i < action.properties.segments.length; i++) {
                        let a = i + 1;
                        newState[i + 1].distance = action.properties.segments[i].distance;
                        newState[i + 1].duration = action.properties.segments[i].duration;
                        if (!action.skipSegments.includes(a)) {
                            newState[i + 1].boat = false;
                        } else {
                            newState[i + 1].boat = true;
                        }
                    }
                    return newState;
                } else {
                    return state;
                }
            }
        default:
            return state
    }
};

export default itinerary
